<template>
  <div class="upload-file__container">
    <div class="file-dropzone">
      <div
        v-if="uploadFileStatus === 'STATUS_UPLOADING'"
        class="file-dropzone__wrapper sending"
      >
        <img
          class="icon"
          src="/static/images/file-uploading.svg"
          alt="Ícone upload em andamento"
        >

        <p class="file-dropzone__text">
          Realizando upload do arquivo…
        </p>
        <loading />
        <a
          class="file-dropzone__cancel-link"
          @click="closeModalContainer"
        >Cancelar</a>
      </div>
      <div
        v-else
        class="file-dropzone__wrapper"
      >
        <div
          v-if="step === 1"
          class="file-dropzone__step file-dropzone__step--step1"
        >
          <file-upload
            ref="upload"
            v-model="files"
            post-action="/upload/post"
            :multiple="false"
            :drop="true"
            :drop-directory="true"
            :accept="accept"
            @input-file="onFileDropped"
          >
            <div class="file-dropzone__box">
              <img
                class="icon"
                src="/static/images/drag-drop-file.svg"
                alt="Ícone Upload de arquivo"
              >

              <p class="file-dropzone__text dropzone_label">
                Arraste e solte o arquivo aqui, ou
              </p>
              <form id="fileParentFile">
                <input
                  id="fileUpload"
                  type="file"
                  class="hide-input"
                  required
                  accept="text/plain, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  name="fileUpload"
                  @change="onFileChange"
                >
              </form>
              <label
                id="mod_btnChooseFile"
                for="fileUpload"
                class="btn btn-nonenary"
                @click="setuploadFileStatusMessage(null)"
              >
                SELECIONE O ARQUIVO
              </label>
              <a
                id="mod_btnFileCancel"
                class="file-dropzone__cancel-link"
                @click="closeModalContainer"
              > Cancelar </a>
            </div>
          </file-upload>
        </div>
        <div
          v-if="step === 2"
          class="file-dropzone__step file-dropzone__step file-dropzone__step--step2"
        >
          <div class="file-dropzone__attachment">
            <img
              src="/static/images/icon-attachment-clip.svg"
              alt="Arquivo anexado"
            >
            <span>{{ uploadData.file.name }}</span>
            <button @click="removeFile">
              <img
                src="/static/images/icon-delete.svg"
                alt="Excluir anexado"
              >
            </button>
          </div>
          <div class="file-dropzone__form">
            <div class="select-wrapper">
              <p class="select-wrapper__label">
                Selecione as opções abaixo para seu arquivo:*
              </p>
              <div
                ref="selectPerfil"
                class="select"
                :class="{ 'select--open': opened }"
                @click="toggleSelect"
              >
                <div
                  class="select__trigger"
                  :class="{ active: optionChoosed }"
                >
                  <span>{{ placeholder }}</span>
                  <div class="arrow" />
                </div>
                <div class="select__options">
                  <template v-for="option in listProfileIds">
                    <span
                      :key="option.id_profile"
                      class="select__option"
                      :data-value="option.id_profile"
                      @click="selectValue(option)"
                    >
                      {{ option.name }}
                    </span>
                  </template>
                </div>
              </div>

              <md-layout
                :md-flex="100"
                :md-flex-medium="100"
                class="datepicker"
              >
                <v-date-picker
                  v-model="uploadData.collectDate"
                  v-validate="'check_date_format:DD/MM/YYYY|not_future_date|after_date:31/12/1899'"
                  v-mask="'##/##/####'"
                  class="collect-date"
                  :pane-width="290"
                  :tint-color="'#7f1a54'"
                  mode="single"
                  data-vv-validate-on="none"
                  maxlength="10"
                  title
                  :popover-content-offset="0"
                  name="collectDate"
                  expanded
                  @keydown.enter.native="focusNextField('txtNewCollectHour')"
                >
                  <md-input-container
                    id="patientCollectDate"
                    slot-scope="{ inputValue, updateValue }"
                    :class="{ 'md-input-invalid': errors.has('collectDate') }"
                  >
                    <label>Data da coleta*</label>
                    <md-input
                      id="dtNewCollectDate"
                      type="text"
                      :value="inputValue"
                      :placeholder="'Data da coleta*'"
                      expanded
                      @change.native="updateValue($event.target.value)"
                    />
                    <md-icon>date_range</md-icon>
                    <span
                      v-if="errors.firstByRule('collectDate', 'check_date_format')"
                      class="md-error"
                    >Valor inválido</span>
                    <span
                      v-else-if="errors.firstByRule('collectDate', 'not_future_date')"
                      class="md-error"
                    >Data não pode ser maior que a atual</span>
                    <span
                      v-else-if="errors.firstByRule('collectDate', 'after_date')"
                      class="md-error"
                    >Ano deve ser maior que 1899</span>
                    <span
                      v-else-if="emptyDate"
                      class="md-error md-error--custom"
                    >É necessário preencher a Data da coleta.</span>
                  </md-input-container>
                </v-date-picker>
              </md-layout>

              <md-layout
                md-flex="100"
                md-flex-medium="100"
              >
                <md-switch
                  v-model="uploadData.glycatedHemoglobin"
                  name="diabeticExame1"
                  class="md-primary"
                >
                  Incluir exame HBGLI para diabéticos
                </md-switch>
              </md-layout>

              <md-layout
                md-flex="100"
                md-flex-medium="100"
              >
                <md-switch
                  v-model="uploadData.glucose"
                  name="diabeticExame2"
                  class="md-primary"
                >
                  Incluir exame Glicose para diabéticos
                </md-switch>
              </md-layout>
            </div>

            <div class="file-dropzone__actions">
              <button
                class="btn btn-outline file-dropzone__cancel"
                @click="closeModalContainer"
              >
                Cancelar
              </button>

              <button
                class="btn btn-primary file-dropzone__submit"
                :disabled="!optionChoosed"
                @click="uploadingFile"
              >
                Finalizar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="uploadFileStatusMessage"
        id="errorMessage"
        class="error-message"
      >
        <div class="error-message__message">
          <md-icon>error_outline</md-icon>
          {{ uploadFileStatusMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/index'
import examProfileService from '@/api/examProfile'
import Moment from 'moment'
import { mask } from 'vue-the-mask'
import FileUpload from 'vue-upload-component'

export default {
  name: 'UploadFile',
  components: {
    FileUpload
  },
  data() {
    return {
      files: [],
      accept:
          'text/plain, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
      uploadData: {
        file: [],
        perfilIdToExport: '',
        collectDate: null,
        glycatedHemoglobin: false,
        glucose: false
      },
      step: 1,
      listProfileIds: [],
      opened: false,
      placeholder: 'Selecione o perfil de exames',
      optionChoosed: false,
      emptyDate: false
    }
  },
  methods: {
    ...mapActions(['setuploadFileStatusMessage']),
    ...mapActions(['uploadFile']),
    closeModalContainer() {
      this.$emit('closeModalContainer')
      if (this.uploadData.file) {
        this.files = []
        this.uploadData.file = null
        this.step = 1
      }
    },
    onFileDropped(data) {
      if (!data) return

      if (
        data.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
          data.file.type !== 'application/vnd.ms-excel' &&
          data.file.type !== 'text/plain'
      ) {
        this.uploadData.file = null
        store.dispatch('setuploadFileStatusMessage', 'Formato de arquivo inválido.')
        return
      }

      this.setuploadFileStatusMessage(null)
      this.uploadData.file = data.file
      this.getListProfileId()
      this.step = 2
    },
    onFileChange(e) {
      this.setuploadFileStatusMessage(null)
      this.uploadData.file = e.target.files[0] || e.dataTransfer.files[0]
      let parent = document.getElementById('fileParentFile')
      parent.reset()
      this.getListProfileId()
      this.step = 2
    },
    uploadingFile() {
      if (!this.uploadData.collectDate) {
        this.emptyDate = true
      } else {
        this.emptyDate = false

        const data = {
          file: this.uploadData.file,
          id: this.uploadData.perfilIdToExport,
          collectDate: Moment(this.uploadData.collectDate).format('YYYY-MM-DD'),
          ...(this.uploadData.glycatedHemoglobin ? { glycatedHemoglobin: this.uploadData.glycatedHemoglobin } : {}),
          ...(this.uploadData.glucose ? { glucose: this.uploadData.glucose } : {}),
          profile: this.profile.laboratoryTypeOutputResult
        }

        this.uploadFile(data)

        this.file = []
        this.uploadData.file = null
        this.placeholder = 'Selecione'
        this.optionChoosed = false
        this.uploadData.collectDate = null
        this.uploadData.glycatedHemoglobin = false
        this.uploadData.glucose = false

        this.$analytics.pushAnalyticsEvent('ga-event', {
          category: 'Importação de Arquivo',
          action: 'Selecione o Arquivo',
          'id-user': this.profile.id,
          'id-lab': this.profile.id_laboratory,
          'name-lab': this.profile.laboratoryName
        })
      }
    },
    getListProfileId() {
      examProfileService
        .getExamProfiles()
        .then(response => {
          this.listProfileIds = response.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    toggleSelect() {
      this.opened = !this.opened
    },
    selectValue(data) {
      this.placeholder = data.name
      this.optionChoosed = true
      this.uploadData.perfilIdToExport = data.id_profile
    },
    removeFile() {
      this.step = 1
      this.files = []
      this.uploadData.file = null
      this.placeholder = 'Selecione'
      this.optionChoosed = false
      this.uploadData.collectDate = null
      this.uploadData.glycatedHemoglobin = false
      this.uploadData.glucose = false
    },
    getClickOutside(evt) {
      const myElement = this.$refs.selectPerfil
      let targetElement = evt.target

      do {
        if (targetElement === myElement) return

        targetElement = targetElement.parentNode
      } while (targetElement)

      this.opened = false
    }
  },
  mounted() {
    document.addEventListener('click', evt => this.getClickOutside(evt))
  },
  beforeDestroy() {
    document.addEventListener('click', evt => this.getClickOutside(evt))
  },
  computed: {
    ...mapGetters(['profile']),
    ...mapGetters(['uploadFileStatus']),
    ...mapGetters(['uploadFileStatusMessage']),
    ...mapGetters(['isUploadFileModalVisible'])
  },
  watch: {
    isUploadFileModalVisible() {
      this.uploadData.file = null
      this.step = 1
    }
  },
  directives: {
    mask: mask
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/01-settings/config-base';

  .upload-file__container {
    position: relative;

    .file-dropzone {
      width: 100%;
      height: 100%;
      position: relative;

      &__text {
        font-size: 15px;
        margin: 16px 0 17px;
        display: block;
        color: rgba(96, 96, 96, 0.87);

        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          margin: 14px 0 16px;
        }
      }

      &__cancel-link:not(.md-button) {
        display: block;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: normal;
        text-align: center;
        color: rgba(96, 96, 96, 0.87);
        text-decoration: underline;
        margin: 37px 0 10px;
        cursor: pointer;
        z-index: 1050;

        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          margin-top: 37px;
        }

        &:hover {
          color: #000;
        }
      }

      &__wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .icon {
          margin: 52px 0 8px;
          height: 106px;
        }

        &.sending {
          .icon {
            margin: 69px 0 15px;
          }

          .file-dropzone__text {
            margin-bottom: 15px;
          }

          .file-dropzone__cancel-link:not(.md-button) {
            margin-top: 29px;
            cursor: pointer;
          }
        }
      }

      &__step {
        width: calc(100% - 40px);
        height: 100%;

        .file-uploads {
          width: 100%;
        }

        &--step1 {
          padding: 10px;
          background-color: #ebebeb;
        }
      }

      .file-dropzone__wrapper {
        .dropzone_label {
          color: rgba(96, 96, 96, 0.87);
        }
      }

      &__box {
        display: flex;
        flex-direction: column;
        align-items: center;
        border: dashed 1px #929292;
        width: 100%;
        height: 100%;
      }

      &__attachment {
        width: 100%;
        display: flex;
        justify-content: space-between;
        min-height: 60px;
        align-items: center;
        padding: 15px;
        background: #ffffff;
        border: 1px solid #ebebeb;
        box-shadow: 0px 1px 3px rgba(121, 121, 121, 0.12);
        border-radius: 3px;
        margin-top: 20px;

        span {
          font-size: 12px;
          flex-grow: 1;
          margin: 10px;
          text-transform: uppercase;
          font-weight: 700;
          color: #7a7a7a;
        }

        img {
          width: 16px;
        }

        button {
          background: #7f1a54;
          border: none;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 19px;
          }
        }
      }

      &__form {
        display: flex;
        flex-direction: column;
        margin-top: 30px;
      }

      &__actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;

        button {
          width: 161px;
          border-radius: 3px;
          text-transform: uppercase;
        }
      }

      &__cancel {
        background: #fff;
        border: 1px solid #7f1a54;
        color: #7f1a54;
      }
    }

    .select-wrapper {
      position: relative;
      user-select: none;
      width: 100%;

      &__label {
        font-size: 15px;
        margin-bottom: 15px;
      }
    }

    .select {
      position: relative;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      border-bottom: 1px solid #b8b7bf;

      &:hover {
        cursor: pointer;
      }

      &--open {
        .select__options {
          opacity: 1;
          visibility: visible;
          pointer-events: all;
          max-height: 200px;
          overflow: auto;
        }

        .select__trigger {
          border-radius: 3px 3px 0 0;
        }

        .arrow:after {
          transform: rotateX(180deg);
          border-width: 5px 5px 0 5px;
        }
      }

      &__trigger {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        color: #7a7a7a;
        height: 36px;
        line-height: 36px;
        background: #ffffff;
        cursor: pointer;
        border-radius: 3px;
        overflow: hidden;

        &.active {
          color: #303030;
        }
      }

      &__options {
        position: absolute;
        display: block;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        z-index: 2;
        border-radius: 0 0 3px 3px;
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.08), 0 7px 7px rgba(0, 0, 0, 0.04), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
        transition: all 0.5s;
      }

      &__option {
        position: relative;
        display: block;
        padding: 0 22px 0 22px;
        color: #303030;
        line-height: 36px;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          cursor: pointer;
          background-color: #fafafa;
        }

        &.selected {
          color: #ffffff;
          background-color: #fafafa;
        }
      }
    }

    .arrow {
      position: relative;
      height: 15px;
      width: 15px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:after {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-top: 5px solid #7a7a7a;
        border-right: 5px solid transparent;
        border-left: 5px solid transparent;
        border-bottom: 0 solid #7a7a7a;
        overflow: hidden;
        transition: 0.3s ease;
      }
    }

    .collect-date {
      width: 100%;
      margin-top: 24px;

      .md-error {
        &--custom {
          opacity: 1;
          transform: translate3d(0, 0, 0);
          color: red;
        }
      }
    }
  }

  #modFileUploadComponents {
    z-index: 9999;

    .md-dialog {
      overflow: inherit;

      &-content {
        padding: 0 8px 34px;
        overflow: inherit !important;
      }
    }

    .md-icon {
      color: #dadada;
    }

    .md-input-focused {
      .md-icon {
        color: #dadada;
      }
    }
  }

  #mod_btnChooseFile {
    width: 253px;
    text-align: center;
    padding: 12px;
    background: none;
    border: 2px solid #7f1a54;
    border-radius: 6px;
    color: #7f1a54;
    position: inherit;
    opacity: 1;
    font-size: 14px;
    z-index: 1050;

    &:hover:not([disabled]) {
      background-color: #7f1a54;
      color: #fff;
    }
  }

  .error-message {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 20px;
    width: 100%;
    opacity: 0.85;
    background-color: #7f1a54;
    font-size: 14px;
    letter-spacing: -0.2px;
    color: rgba(255, 255, 255, 0.87);
    height: auto;
    display: flex;
    align-items: center;

    .md-icon {
      margin: 0 4px 0 0;
      flex-grow: 0;
    }

    &__message {
      text-overflow: ellipsis;
      white-space: normal;
      display: block;
      overflow: hidden;
      width: 100%;
      text-align: center;
    }
  }
</style>
